import { Mail, ExternalLink } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F172A] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/logo.png"
                alt="DRE+ Logo"
                className="w-12 h-12 rounded-full object-contain"
                style={{
                  filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 1)) drop-shadow(0 0 16px rgba(255, 255, 255, 0.8)) drop-shadow(0 0 24px rgba(59, 130, 246, 0.5))',
                  background: 'white',
                  padding: '2px'
                }}
              />
              <span className="font-heading font-bold text-xl">Controle Financeiro</span>
            </div>
            <p className="text-slate-400 leading-relaxed">
              Sistema de gestão financeira para pequenas e médias empresas. Controle contas a pagar, contas a receber e tenha relatórios completos do seu negócio.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-4">Links Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <a href="#features" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-link-features">
                  Funcionalidades
                </a>
              </li>
              <li>
                <a href="#screenshots" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-link-screenshots">
                  Screenshots
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-link-testimonials">
                  Depoimentos
                </a>
              </li>
              <li>
                <a href="#faq" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-link-faq">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Access */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-4">Acesse o Sistema</h4>
            <a
              href="https://app.dremais.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#047857] hover:bg-[#065F46] text-white px-6 py-3 rounded-full font-semibold transition-colors mb-4"
              data-testid="footer-cta"
            >
              Entrar no DRE+
              <ExternalLink className="w-4 h-4" />
            </a>
            <a 
              href="mailto:suporte@dremais.com.br?subject=Quero%20saber%20mais%20sobre%20a%20aplica%C3%A7%C3%A3o%20de%20controle%20financeiro%20DRE%2B&body=Quero%20saber%20mais%20sobre%20a%20aplica%C3%A7%C3%A3o%20de%20controle%20financeiro%20DRE%2B"
              className="text-slate-400 text-sm hover:text-white transition-colors block"
              data-testid="footer-email-link"
            >
              <Mail className="w-4 h-4 inline mr-2" />
              suporte@dremais.com.br
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm" data-testid="footer-copyright">
              &copy; {currentYear} DRE+ Controle Financeiro. Todos os direitos reservados.
            </p>
            <div className="flex gap-6">
              <a href="/termos" className="text-slate-400 hover:text-white text-sm transition-colors">
                Termos de Uso
              </a>
              <a href="/privacidade" className="text-slate-400 hover:text-white text-sm transition-colors">
                Política de Privacidade
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
